import { OLMSApiService } from '@/shared/apis'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { upsertMultipleDrivers } from '../driversSlice'
import { Driver } from '../models/Driver'

export const fetchDrivers = createAsyncThunk('drivers/fetch', async (_, { dispatch }) => {
  const drivers = await OLMSApiService.get<Driver[]>('/driver/list')

  if (drivers && drivers.length > 0) {
    dispatch(upsertMultipleDrivers(drivers))
  }
})